import { scheduler, Scheduler } from "./dhtmlxscheduler.enterprise";
export default scheduler;
export { scheduler, Scheduler };